<template>
    <div class="app">
        <scroll @refresh="refresh" class="report-detail">
            <div class="report-detail-title icon-msg-h">
                <span class="icon report-item-img"></span>
                <div class="f-largest">{{queryParam.examItem}}</div>
            </div>
            <section class="report-detail-qrcode thick" v-show="qrcodeEnable">
                <!--<div>-->
                <p>打印报告二维码</p>
                <!--<div class="bar-code-bg">-->
                <!--<svg id="barcode"></svg>-->
                <!--</div>-->
                <section class="thick" style="margin-top: 40px">
                    <!--<div class="row" style="padding: 1.25rem 0 1.5rem 1.25rem"></div>-->
                    <qrcode :size="171" class="qrcode" :cls="qrCls" :value="qrText"></qrcode>
                    <o2o-helper :type="0"></o2o-helper>
                </section>
                <!--<o2o-helper :type="1"></o2o-helper>-->
            </section>
            <section class="thick">
                <dl class="field">
                    <dd>{{examDetail.hospitalName}}</dd>
                </dl>
                <!--<dl class="field">-->
                <!--<dd>获取不到科室</dd></dl>-->
                <!--<dl class="field">-->
                <!--<dt >门诊医生</dt> <dd>获取不到医生</dd></dl>-->
                <dl class="field">
                    <dt>卡号</dt>
                    <dd>{{examDetail.cardNo}}</dd>
                </dl>
                <dl class="field">
                    <dt>报告单号</dt>
                    <dd>{{queryParam.examId}}</dd>
                </dl>
                <dl class="field">
                    <dt>出单时间</dt>
                    <dd>{{queryParam.examTime}}</dd>
                </dl>
            </section>
            <section class="thick" v-for="(item, index) in examDetail.items" @click="showDetail(item)">
                <div class="title f-strong">
                    <div style="width: 90%;display: inline-block;">{{item.examItem}}</div>
                    <span v-if="!item.showDetailInfo" class="arr-gray-down"></span>
                    <span v-if="item.showDetailInfo" class="arr-gray-up"></span>
                </div>
                <div v-show="item.showDetailInfo" style="background: #f8f8f8">
                    <dl class="field">
                        <dt>检查部位</dt>
                    </dl>
                    <div class="row">
                        <dd>{{item.examPart}}</dd>
                    </div>
                    <dl class="field">
                        <dt>检查所见</dt>
                    </dl>
                    <div class="row">
                        <dd>{{item.examView}}</dd>
                    </div>
                    <div class="field">
                        <span class="f-minor">诊疗意见及建议</span></div>
                    <div class="row">
                        <dd>{{item.diagnosis}}</dd>
                    </div>
                </div>
            </section>
        </scroll>
    </div>
</template>
<script>
    import queryFunDetail from 'queryFunDetail.service'
    import O2oHelper from 'O2OHelper'
    import Qrcode from 'v-qrcode'
    export default {
        components: {
            O2oHelper,
            Qrcode
        },
        data(){
            return {
                examDetail: {},
                toggles: [false, false],
                queryParam: {},
                show: false,
                items: [],
                qrCls: 'qrcode',
                qrText: '',
                qrcodeEnable: false
            }
        },
        mounted(){
            this.refresh();
        },
        methods: {
            refresh(){
                this.queryParam = this.param.queryParam;
                queryFunDetail.getExamDetail(this.queryParam).then((res) => {
                    if (res.resultCode === this.constant.RESULT_SUCCESS) {
                        for (var i = 0; i < res.data.items.length; i++) {
                            res.data.items[i].showDetailInfo = false;
                            if (i === 0) {
                                res.data.items[i].showDetailInfo = true;
                            }
                        }
                        this.examDetail = res.data;
                        this.qrText = this.examDetail.qrCode;
                    } else {
                        this.$utils.alert(res.resultMsg)
                    }
                })
            },
            showHelp() {
                this.show = !this.show;
            },
            showDetail(item) {
                item.showDetailInfo = !item.showDetailInfo;
            }
        },
        computed: {
            param() {
                return this.$store.state.paramModule.param.myExam;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ExamDetail.vue?ab8382c0